import { createContext } from "react";


class NewsStore {
  columnVisibility = {}
  columnFilters = []
  globalFilter = undefined
  searchField = 'title'
  pagination = { pageIndex: 0, pageSize: 10 }
  // State preservation fields
  tableData = []
  isLoading = true
  isRefetching = false
  open = false
  scrollTop = 0
  needsRefresh = false
}


export const newsStore = new NewsStore()
export const NewsStoreContext = createContext(newsStore)
